import { Space } from '@sravni/react-design-system/lib/Space';
import { useIsMobile } from '@sravni/react-utils';

import type { TButtonFlow, TOnClickFlow } from 'commonTypes/api/scenarios/BaseTypes';

import { VerificationInstructionsButton } from '../VerificationInstructionsButton';

type VerificationInstructionsButtonsProps = {
  buttons: Array<TButtonFlow<TOnClickFlow>>;
};

export const VerificationInstructionsButtons = (props: VerificationInstructionsButtonsProps) => {
  const { buttons } = props;
  const isMobile = useIsMobile();

  return (
    <Space
      direction={isMobile ? 'vertical' : 'horizontal'}
      justify="space-between"
      size={isMobile ? 8 : 16}
    >
      {buttons?.map((button) => (
        <VerificationInstructionsButton
          key={button.title}
          button={button}
          size={52}
          block={isMobile}
        />
      ))}
    </Space>
  );
};
